import React, { useContext } from 'react'
import GreyBoxForReports from './GreyBoxForReports'
import { ApiGetCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import {  formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY } from '../../JS/Common';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';

export default function AllRocketAccounts({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    const {secondary_text} = useConfig();
    async function GetAllAccountsData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);
        await ApiGetCall(`/reports/school-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&flag=${downloadall}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    DownloadCsv(responseRs);
                } else {
                    DownloadCsv([]);
                    setalerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
                    setTimeout(() => {
                        setalerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            }
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            const rowData = {
                'Account Name': item.name,
                'Domain': item.domain,
                'Location': item.location_name,
                'Shipping Type': item.mail_in_or_local,
                'Active': item.status,
                'Account Created Date': item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'
            };
            PurchaseMap.push(rowData);
        });

        if (PurchaseMap.length > 0) {
            const headers = ['Account Name', 'Domain', 'Location', 'Shipping Type', 'Active', 'Account Created Date'];
            csvContent.push(headers);
            PurchaseMap.forEach((rowData) => {
                const values = Object.values(rowData).map(value => {
                    if (typeof value == 'string' && value.includes(',')) {
                        return `"${value}"`;
                    }
                    return value;
                });
                csvContent.push(values);
            });
            csvContent.push([]);
            const csvString = csvContent.map((row) => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'AllAccounts.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            log.error('No data available for download.');
        }
    };
    return (
        <GreyBoxForReports icon="faReceipt" name={`All ${secondary_text} Accounts Report Download`} onclickfunc={GetAllAccountsData} />
    )
}
